import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    Renderer2,
    ViewEncapsulation
} from '@angular/core';
import {GenericFormGroupComponent} from '../../forms/generic-form-group.component';
import {RosterService} from '../../shared/roster.service';

import {
    Roster,
    Student,
    StudentGradeValidation,
    StudentGradeValidationError
} from '../../shared/interface/roster.interface';
import {CourseService} from '../../shared/course.service';
import {CourseCacheService} from '../../shared/course-cache.service';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {AlertService} from '../../shared/services/alert.service';
import {GradeSubmitStatusComponent} from '../grade-submit-status/grade-submit-status-component';
import {GradeList} from '../../shared/interface/grading-rule.interface';
import {GradeConfirmation, GradeConfirmationData} from '../../shared/interface/submit-grade-confirmation.interfaces';
import {SubmitConfirmationComponent} from '../submit-confirmation/submit-confirmation.component';
import {GradeStatementScenarioType} from '../../shared/enum/grade-statement-scenario-type';
import {EnrollmentSource} from '../../shared/enum/enrollment-source';

@Component({
    selector: 'app-roster-roster-button',
    templateUrl: './roster-button.component.html',
    styleUrls: ['./roster-button.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class RosterButtonComponent extends GenericFormGroupComponent implements OnInit {
    constructor(
        public dialog: MatDialog,
        private rosterService: RosterService,
        private courseService: CourseService,
        private courseCacheService: CourseCacheService,
        protected renderer2: Renderer2,
        private alert: AlertService,
        private changeDetectRef: ChangeDetectorRef
    ) {
        super(renderer2);
    }

    @Input() termCode: string;
    @Input() crn: string;
    @Input() isDataLoaded: boolean;
    @Input() updateStudentList: Student[];
    @Input() gradeGDList: Array<GradeList>;
    @Input() gradeIList: Array<GradeList>;
    @Input() allowReSubmitRoster: boolean;

    @Output() processSaveGrade: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() mainValidationErrorMessage: EventEmitter<Array<String>> = new EventEmitter<Array<String>>();
    @Output() isDataLoadedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() requestUpdateRoster: EventEmitter<boolean> = new EventEmitter<boolean>();

    cannotSubmitGradeMessages: string[] = [];
    allStudentHasGrade: boolean = false;
    allGDWithOEHaveGrade: boolean = false;
    atLeastOneStudentCanGrade: boolean = false;
    atLeastOneStudentWithGradeChange: boolean = false;

    gradeConfirmationData: GradeConfirmationData;

    readonly enrollmentSource: EnrollmentSource = EnrollmentSource.getInstance();

    ngOnInit(): void {
        this.courseCacheService.setCache(this.termCode, this.crn);
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.changeDetectRef.detectChanges();
        //this.requestUpdateRoster.emit(true);
    }

    cannotSubmitGradeMessage(): string {

        /*
        console.log('this.allStudentHasGrade =' + this.allStudentHasGrade);
        console.log('this.atLeastOneStudentWithGradeChange =' + this.atLeastOneStudentWithGradeChange);
        console.log('this.allowReSubmitRoster =' + this.allowReSubmitRoster);
        console.log('this.atLeastOneStudentWithGradeChange =' + this.atLeastOneStudentWithGradeChange);
        console.log('this.courseService.currentCourse.isBannerInMaintenance =' + this.courseService.currentCourse.isBannerInMaintenance);
        console.log('this.courseService.currentCourse.canInstructorSubmit =' + this.courseService.currentCourse.canInstructorSubmit);
        console.log('this.courseService.currentCourse.canCourseBeGraded =' + this.courseService.currentCourse.canCourseBeGraded);
        console.log('this.courseService.currentCourse.isGradingOpen =' + this.courseService.currentCourse.isGradingOpen);

*/
        this.cannotSubmitGradeMessages = [];

        if (!this.atLeastOneStudentWithGradeChange) {
            this.cannotSubmitGradeMessages.push('At least one student does not have a grade assigned.\n');
        } else if (!this.atLeastOneStudentWithGradeChange && !this.allowReSubmitRoster) {
            this.cannotSubmitGradeMessages.push('No Grade Changes Have Been Entered.\n');
        }

        if (this.courseService.currentCourse.isBannerInMaintenance) {
            this.cannotSubmitGradeMessages.push('Banner is in maintenance.\n');
        }
        if (!this.courseService.currentCourse.canInstructorSubmit) {
            this.cannotSubmitGradeMessages.push(
                'User is not authorized to submit grades. If you feel this message is in error, please contact your department scheduling coordinator..\n'
            );
        }
        if (!this.courseService.currentCourse.canCourseBeGraded) {
            this.cannotSubmitGradeMessages.push('Non-Gradable Section.\n');
        }

        if (!this.courseService.currentCourse.isGradingOpen) {
            this.cannotSubmitGradeMessages.push('Grading Closed.\n');
        }

        //only above is true
        if (this.cannotSubmitGradeMessages?.length === 0) {
            if (!this.allStudentHasGrade) {
                this.cannotSubmitGradeMessages.push('At least one student does not have a grade assigned.\n');
            }
            if (!this.allGDWithOEHaveGrade) {
                this.cannotSubmitGradeMessages.push('All Banner student have grade of GD.\n');
            }
            if (!this.atLeastOneStudentCanGrade) {
                this.cannotSubmitGradeMessages.push('None of the student can have grade change.\n');
            }
        }

        if (this.cannotSubmitGradeMessages?.length === 0) {
            return null;
        } else {
            this.cannotSubmitGradeMessages.unshift('Unable to submit grades due to the following reason(s):\n');
            this.cannotSubmitGradeMessages.unshift(
                `CRN: ${this.courseService.currentCourse.crn} ${this.courseService.currentCourse.termCodeDescription}\n`
            );
            return this.cannotSubmitGradeMessages.join('\n');
        }
    }

    //use this function button to show Submit grade button
    canSubmitGrade(): boolean {
        //emitt get list of roster from main datasource
        if (!this.updateStudentList) {
            return false;
        }

        //get list of banner student
        const bannerAndUNEXStudent = this.updateStudentList.filter(
            (item: Student) =>
                [this.enrollmentSource.Banner, this.enrollmentSource.UNEX].indexOf(item.enrollmentSource) !== -1
        );

        // get the size of banner student
        const numBannerStudent = bannerAndUNEXStudent.length;

        //from list of student in Banner, find how many student has a grade.
        const allStudentWithGradesList = bannerAndUNEXStudent.filter(
            (item: Student) => item.gradeIGrade != undefined && true && item.gradeIGrade != ''
        );

        const allStudentThatCannotChangeGrade = bannerAndUNEXStudent.filter(
            (item: Student) => !item.canGradeBeModified
        )?.length;

        const allBannerStudentWithGradeChange = bannerAndUNEXStudent.filter(
            (item: Student) => item.gradeIGrade != item.gradeOriginalIGrade
        )?.length;

        // get number of student with iGrade
        const numGDGrade = bannerAndUNEXStudent.filter((item: Student) => item.gradeBanner === 'GD').length;
        //from banner student get number of gd grade
        const numIGradeGD = allStudentWithGradesList.filter((item: Student) => item.gradeIGrade === 'GD').length;
        // size of student with grades
        const allStudentWithGrades = allStudentWithGradesList.length;

        /* setup the rules and condition


         */
        // number of banner student and number of student with grade
        this.allStudentHasGrade = numBannerStudent === allStudentWithGrades;

        // all grades roll over.  number of GD grade cannot be same as number of banner student
        this.allGDWithOEHaveGrade = numIGradeGD != numBannerStudent;

        // all student that cannot change needs to be less than total of banner students
        this.atLeastOneStudentCanGrade = allStudentThatCannotChangeGrade < numBannerStudent;

        this.atLeastOneStudentWithGradeChange = allBannerStudentWithGradeChange > 0;

        /*
        console.log('numBannerStudent' + numBannerStudent);
        console.log('allStudentWithGrades' + allStudentWithGrades);
        console.log('this.allStudentHasGrade' + this.allStudentHasGrade);
        console.log('numIGradeGD' + numIGradeGD);
        console.log('numBannerStudent' + numBannerStudent);
        console.log('this.allGDWithOEHaveGrade' + this.allGDWithOEHaveGrade);
        console.log('allStudentThatCannotChangeGrade' + allStudentThatCannotChangeGrade);
        console.log('numBannerStudent' + numBannerStudent);
        console.log('this.atLeastOneStudentCanGrade' + this.atLeastOneStudentCanGrade);
        console.log('allBannerStudentWithGradeChange' + allBannerStudentWithGradeChange);
        console.log('this.atLeastOneStudentWithGradeChange' + this.atLeastOneStudentWithGradeChange);
*/

        if (this.allStudentHasGrade && this.allowReSubmitRoster) {
            return true;
        }

        if (
            this.courseService.currentCourse.canInstructorSubmit &&
            this.courseService.currentCourse.canCourseBeGraded &&
            this.courseService.currentCourse.isGradingOpen // remove this logic is grading open
        ) {


            if (
                this.allStudentHasGrade &&
                this.allGDWithOEHaveGrade &&
                this.atLeastOneStudentCanGrade &&
                this.atLeastOneStudentWithGradeChange &&
                this.atLeastOneStudentWithGradeChange
            ) {
                return true;
            }
        }

        // always return false if it cannot fall into the true condition
        return false;
    }

    onSaveGrade() {
        this.isDataLoadedChange.emit(false);
        this.processSaveGrade.emit(true);
    }

    onProcessGradeSubmit() {
        //need to see if we have any to show

        this.gradeConfirmationData = {
            gradeGDConfirmation: {
                numberOfStudent: 0,
                needToConfirm: false,
                isConfirm: false,
                confirmDate: null,
                hideConfirm: true
            },
            gradeIConfirmation: {
                numberOfStudent: 0,
                needToConfirm: false,
                isConfirm: false,
                confirmDate: null,
                hideConfirm: true
            },
            gradeChangeConfirmation: {
                numberOfStudent: 0,
                needToConfirm: false,
                isConfirm: false,
                confirmDate: null,
                hideConfirm: true
            }
        };

        this.gradeConfirmationData.gradeGDConfirmation.numberOfStudent = 0;
        this.gradeConfirmationData.gradeIConfirmation.numberOfStudent = 0;
        this.gradeConfirmationData.gradeChangeConfirmation.numberOfStudent = 0;

        //find number of GD
        this.updateStudentList.forEach((student: Student) => {
            //only process for banner student not other
            if (student.enrollmentSource === 'Banner' && student.gradeIGrade != student.gradeOriginalIGrade) {
                if (
                    this.gradeGDList.findIndex(
                        (item: GradeList) => item.grade == student.gradeIGrade && student.shrtckgGCHGCode != 'OE'
                    ) >= 0
                ) {
                    this.gradeConfirmationData.gradeGDConfirmation.numberOfStudent++;
                }
                if (this.gradeIList.findIndex((item: GradeList) => item.grade == student.gradeIGrade) >= 0) {
                    this.gradeConfirmationData.gradeIConfirmation.numberOfStudent++;
                }
                if (student.gradeIGrade != student.gradeOriginalIGrade && student.shrtckgGCHGCode) {
                    this.gradeConfirmationData.gradeChangeConfirmation.numberOfStudent++;
                }
            }

        });

        //see if there are any grade change
        //initialized data

        this.gradeConfirmationData.gradeGDConfirmation.needToConfirm =
            this.gradeConfirmationData.gradeGDConfirmation.numberOfStudent > 0;
        this.gradeConfirmationData.gradeIConfirmation.needToConfirm =
            this.gradeConfirmationData.gradeIConfirmation.numberOfStudent > 0;
        this.gradeConfirmationData.gradeChangeConfirmation.needToConfirm =
            this.gradeConfirmationData.gradeChangeConfirmation.numberOfStudent > 0;

        if (
            this.gradeConfirmationData.gradeGDConfirmation.numberOfStudent == 0 &&
            this.gradeConfirmationData.gradeIConfirmation.numberOfStudent == 0 &&
            this.gradeConfirmationData.gradeChangeConfirmation.numberOfStudent == 0
        ) {
            this.confirmToProcessGradeSubmit();
        } else {
            console.log(this.gradeConfirmationData);

            const dialogConfig = new MatDialogConfig();
            dialogConfig.data = this.gradeConfirmationData;
            dialogConfig.disableClose = true;
            dialogConfig.maxWidth = '80%';
            const dialogRef = this.dialog.open(SubmitConfirmationComponent, dialogConfig);
            dialogRef.afterClosed().subscribe((result: GradeConfirmationData) => {
                //add change log for confirm GD, I, and Grade Change
                if (result) {
                    this.confirmToProcessGradeSubmit();
                }
            });
        }
    }

    confirmToProcessGradeSubmit() {
        this.setSaving();
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = this.rosterService.currentRoster;
        dialogConfig.disableClose = true;
        const dialogRef = this.dialog.open(GradeSubmitStatusComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((result: Array<String>) => {
            this.setDoneSaving();
            this.mainValidationErrorMessage.emit(result);
        });
    }
}
